export default __webpack_public_path__ + "static/media/investment.a3ad816b.png";